import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setuserloginStored,
  settokenStored,
  setuserStored,
  setcontrollerStored,
  getcontroller,
} from "../../stored/mydata";

import { socket } from "../../socket";

import { Spin, Modal, Space, Button, Form, Input } from "antd";

export default function Authentication(props) {
  const dataController = useSelector(getcontroller);

  const [form] = Form.useForm();

  const [uuid, setUuid] = useState("");
  const [isShow, setIsshow] = useState(false);
  const [openModalLogin, setOpenModelLogin] = useState(true);
  const [openModalRoom, setOpenModelRoom] = useState(false);

  const dispatch = useDispatch();

  var navigate = useNavigate();

  const handleOkLogin = () => {
    form
      .validateFields()
      .then((values) => {
        if (
          values.user === process.env.REACT_APP_USER &&
          values.password === process.env.REACT_APP_PASS
        ) {
          setOpenModelLogin(false);
          // form.resetFields(); // ล้างข้อมูลในฟอร์มหลังจากส่งข้อมูลสำเร็จ
          setOpenModelRoom(true);
        }
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  const handleCancelLogin = () => {
    setOpenModelLogin(false);
  };

  const handleOkRoom = () => {
    form
      .validateFields()
      .then((values) => {
        console.log(values);
        
        if (values.unit_number && values.house_number && values.project_code) {
          setOpenModelRoom(false);
          // form.resetFields(); // ล้างข้อมูลในฟอร์มหลังจากส่งข้อมูลสำเร็จ
          var roomNumber = {
            unit_number: values.unit_number,
            house_number: values.house_number,
            project_code: values.project_code,
          };
          myRoomTest(roomNumber);
        }
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  const handleCancelRoom = () => {
    setOpenModelRoom(false);
  };

  const myRoomTest = (value) => {
    localStorage.setItem(
      "Obtuser",
      JSON.stringify({
        qr: {},
        uuid: "d62f987d-063d-41b3-8140-1df209be0b1f",
        access_token: "fae69356-04da-4bae-9e66-0425b880138f",
        fullname: "admin obotron",
        phone_number: "0856231452",
        lang: "th",
        project_name_en: "Whizdom All",
        project_name_th: "วิสซ์ดอม ออ",
        unit_number: value.unit_number,
        house_number: value.house_number,
        project_code: value.project_code,
      })
    );

    const localUser = localStorage.getItem("Obtuser");
    // setUserstr(localUser);
    const json_user = JSON.parse(localUser);

    if (
      json_user["uuid"] &&
      json_user["access_token"] &&
      json_user["unit_number"] &&
      json_user["house_number"]
    ) {
      //   setIsshow(true);

      //เปิดใช้งานตอนขึ้นดซิป
      if (process.env.REACT_APP_PROJECT === "production534131") {
        // localStorage.removeItem('Obtuser');
      }
      //เปิดใช้งานตอนขึ้นดซิป

      setUuid(json_user["uuid"]);

      dispatch(setuserloginStored(true));
      dispatch(setuserStored(json_user));
      dispatch(settokenStored(json_user["uuid"]));

      socket.connect();
      socket.emit(
        "join",
        `${json_user.project_code}_${json_user.house_number}`
      );

      let count = 2;
      let timerId = setInterval(() => {
        count--;
        if (count === 0) {
          clearInterval(timerId);

          navigate("/home");
        }
      }, 1000);
    }
  };

  socket.on("message", (data) => {
    console.log("ok");
    if (JSON.stringify(dataController) !== JSON.stringify(data)) {
      dispatch(setcontrollerStored(data));
    } else {
      let count = 10;
      let timerId = setInterval(() => {
        count--;
        if (count === 0) {
          clearInterval(timerId);
        }
      }, 1000);
    }
  });

  return (
    <div style={styles.example}>
      <Modal
        title="Login"
        open={openModalLogin}
        onOk={handleOkLogin}
        onCancel={handleCancelLogin}
      >
        <Form form={form} layout="vertical" name="userForm">
          <Form.Item
            label="User"
            name="user"
            rules={[{ required: true, message: "Please input your username!" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: "Please input your password!" }]}
          >
            <Input.Password />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="Enter Your Information"
        open={openModalRoom}
        onOk={handleOkRoom}
        onCancel={handleCancelRoom}
      >
        <Form form={form} layout="vertical" name="nameForm">
          <Form.Item
            label="Unit number"
            name="unit_number"
            rules={[
              {
                required: true,
                message: "Please input your first Unit number!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="House number"
            name="house_number"
            rules={[
              {
                required: true,
                message: "Please input your last House number!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Project code"
            name="project_code"
            rules={[
              { required: true, message: "Please input your Project code!" },
            ]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

const styles = {
  example: {
    margin: "20px 0",
    marginBottom: "20px",
    padding: "30px 50px",
    textAlign: "center",
    borderRadius: "4px",
  },
  textNodata: {
    color: "#56585D",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "24px",
    letterSpacing: "0.4px",
    fontFamily: "Gotham",
  },
};
